<template>
  <div class="score">
    <div class="body" :style="{ backgroundImage: `url(${backgrounds[setTemplate]})` }">
      <div class="body-score">
        <div class="items">
          <div v-for="index in quiz.questionsCorrect" :key="index + 11" class="circle green-yellow"></div>
          <div
            v-for="index in quiz.wrongQuestions"
            :key="index + 20"
            class="circle"
            :style="{ backgroundColor: incorrectColors[setTemplate] }"
          ></div>
        </div>
        <div class="indicators">
          <span>{{ quiz.questionsCorrect }} of {{ quiz.questionsCorrect + quiz.wrongQuestions }}</span>
        </div>
      </div>
      <div class="body-info">
        <div v-if="nextLesson" class="text">
          <h1>{{ $t('resultsQuiz.approved.title') }}</h1>
          <p>{{ $t('resultsQuiz.approved.msg') }}</p>
        </div>
        <div v-else class="text">
          <h1>{{ $t('resultsQuiz.notApproved.title') }}</h1>
          <p>{{ $t('resultsQuiz.notApproved.msg') }}</p>
        </div>
        <div class="navigation-btn">
          <BtnsNavigation
            class="star"
            :disabled-btn="!nextLesson"
            :disabled-btn-next="nextLesson"
            :colors="buttonColors[setTemplate]"
          ></BtnsNavigation>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import BtnsNavigation from './BtnsNavigation.vue';

export default {
  components: {
    BtnsNavigation,
  },
  props: {
    quiz: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      setTemplate: 0,
      backgrounds: [
        'static/quizz/quizz1.png',
        'static/quizz/quizz2.png',
        'static/quizz/quizz3.png',
        'static/quizz/quizz4.png',
      ],
      incorrectColors: ['#FF94A4', '#747474', '#747474', '#747474'],
      buttonColors: [
        ['#B478D1', '#5EB3E2'],
        ['#9B4919', '#9B4919'],
        ['#429DDD', '#982A7D'],
        ['#429999', '#429999'],
      ],
    };
  },
  computed: {
    nextLesson() {
      return this.quiz.average >= 75;
    },
  },
  created() {
    this.selectBackground();
  },
  methods: {
    selectBackground() {
      this.setTemplate = Math.floor(Math.random() * 4);
    },
  },
};
</script>
<style lang="scss" scoped>
.score {
  .body-header {
    position: relative;
    margin: 15px;
    display: flex;
    justify-content: center;
    img {
      top: -69px;
      right: 220px;
      position: absolute;
      height: 78px;
      width: 75px;
    }
    .point {
      width: 15px;
      height: 15px;
      border-radius: 50%;
      border: 2px solid #89c0c0;
    }
  }
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  .body {
    padding: 140px 15px 15px;
    height: 500px;
    width: 600px;
    border-radius: 15px;
    background-repeat: no-repeat;
    background-position: center;
    background-size: 100% 420px; //background-size: contain;
    .body-score {
      margin: 6% 0;
      .items {
        display: flex;
        justify-content: center;
        .circle {
          margin: 0 6%;
          border-radius: 50%;
          height: 45px;
          width: 45px;
          &.green-yellow {
            background-color: #ced529;
          }
        }
      }
      .indicators {
        margin: 15px 0 0 0;
        display: flex;
        justify-content: center;
      }
    }
    .body-info {
      font-family: 'comfortaaregular';
      .text {
        h1 {
          text-align: center;
          color: #ddba2a;
          font-size: 22px;
        }
        p {
          text-align: center;
          padding: 0 60px; //47
          font-size: 18px;
        }
      }
      .navigation-btn {
        display: flex;
        justify-content: center;
        align-items: center;
        height: 110px;
      }
    }
  }
}
@media (max-width: 575px) {
  .body {
    padding: 140px 10px 15px;
    height: 450px;
    background-size: 90% 360px;
  }
}
@media (min-width: 576px) {
  //final del quiz modo smartphone
  .body {
    padding: 110px 15px 15px;
    height: 390px; //
    border-radius: 15px;
    background-size: 280px 330px;
  }
  .body-info p {
    padding: 0 60px;
  }
}
.pin {
  -webkit-filter: hue-rotate(1deg);
  filter: hue-rotate(1deg);
}
</style>
